import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `.inspection-validation-summary {
  display: flex;
  flex-direction: column;
  gap: ${dt('inspectionValidationSummary.gap')};
  background: ${dt('inspectionValidationSummary.background')};
  border: 1px solid ${dt('inspectionValidationSummary.borderColor')};
  border-radius: ${dt('inspectionValidationSummary.borderRadius')};
  padding: ${dt('inspectionValidationSummary.padding')};
}

.inspection-validation-summary .summary-title {
  color: ${dt('inspectionValidationSummary.title.color')};
  font-size: ${dt('inspectionValidationSummary.title.fontSize')};
  font-weight: ${dt('inspectionValidationSummary.title.fontWeight')};
  line-height: ${dt('inspectionValidationSummary.title.lineHeight')};
  margin: 0;
}

.inspection-validation-summary .summary-list {
  display: flex;
  flex-direction: column;
  gap: ${dt('inspectionValidationSummary.list.gap')};
  color: ${dt('inspectionValidationSummary.list.color')};
  font-size: ${dt('inspectionValidationSummary.list.fontSize')};
  line-height: ${dt('inspectionValidationSummary.list.lineHeight')};
  margin: 0;
  padding-left: 1.25rem;
  list-style-type: disc;
}`;
